/**
 * Maple MC2 — Scroll Animations
 * Usage :
 *   fade-up  → textes, titres, descriptions, boutons, badges
 *   fade-in  → images, photos, fonds visuels
 *
 * Options via data-attributes :
 *   data-delay="200"     → délai en ms avant l'animation (défaut : 0)
 *   data-duration="600"  → durée en ms (défaut : 600)
 *   data-stagger         → sur un parent : anime les enfants directs en cascade
 *   data-stagger-delay="100" → délai entre chaque enfant (défaut : 80ms)
 */
 
(function () {
  'use strict';
 
  // Respecter prefers-reduced-motion
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 
  const DEFAULTS = {
    duration: 600,
    delay: 0,
    staggerDelay: 80,
    threshold: 0.12,
    rootMargin: '0px 0px -40px 0px',
  };
 
  // ── CSS injecté dynamiquement ──────────────────────────────────────────────
  const css = `
    .fade-up,
    .fade-in {
      opacity: 0;
      will-change: opacity, transform;
      transition-property: opacity, transform;
      transition-timing-function: cubic-bezier(0.22, 0.61, 0.36, 1);
      transition-fill-mode: both;
    }
 
    .fade-up {
      transform: translateY(28px);
    }
 
    .fade-in {
      transform: none;
    }
 
    .fade-up.is-visible,
    .fade-in.is-visible {
      opacity: 1;
      transform: translateY(0);
    }
 
    /* Pas d'animation si prefers-reduced-motion */
    @media (prefers-reduced-motion: reduce) {
      .fade-up,
      .fade-in {
        opacity: 1 !important;
        transform: none !important;
        transition: none !important;
      }
    }
  `;
 
  function injectStyles() {
    if (document.getElementById('maple-anim-styles')) return;
    const style = document.createElement('style');
    style.id = 'maple-anim-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }
 
  // ── Appliquer transition-duration et transition-delay inline ──────────────
  function applyTransition(el) {
    const duration = parseInt(el.dataset.duration, 10) || DEFAULTS.duration;
    const delay    = parseInt(el.dataset.delay, 10)    || DEFAULTS.delay;
    el.style.transitionDuration = duration + 'ms';
    el.style.transitionDelay    = delay + 'ms';
  }
 
  // ── Gérer le stagger sur les enfants directs d'un parent ──────────────────
  function applyStagger(parent) {
    const staggerDelay = parseInt(parent.dataset.staggerDelay, 10) || DEFAULTS.staggerDelay;
    const baseDelay    = parseInt(parent.dataset.delay, 10)        || DEFAULTS.delay;
    const children     = Array.from(parent.children);
 
    children.forEach(function (child, i) {
      child.classList.add('fade-up');
      const duration = parseInt(parent.dataset.duration, 10) || DEFAULTS.duration;
      child.style.transitionDuration = duration + 'ms';
      child.style.transitionDelay    = (baseDelay + i * staggerDelay) + 'ms';
    });
  }
 
  // ── IntersectionObserver callback ─────────────────────────────────────────
  function onIntersect(entries, observer) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }
 
  // ── Init principale ────────────────────────────────────────────────────────
  function init() {
    if (prefersReduced) return;
 
    injectStyles();
 
    const observer = new IntersectionObserver(onIntersect, {
      threshold:  DEFAULTS.threshold,
      rootMargin: DEFAULTS.rootMargin,
    });
 
    // 1. Traiter les parents [data-stagger] en premier
    document.querySelectorAll('[data-stagger]').forEach(function (parent) {
      applyStagger(parent);
    });
 
    // 2. Observer tous les éléments .fade-up et .fade-in
    document.querySelectorAll('.fade-up, .fade-in').forEach(function (el) {
      applyTransition(el);
      observer.observe(el);
    });
  }
 
  // ── Lancement ─────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  // Support Shopify section reload dans le theme editor
  document.addEventListener('shopify:section:load', function () {
    init();
  });
 
})();